const getViewerRendersCounter = (state: AnyFixMe) => state.viewerRendersCounter;

export { getViewerRendersCounter };
